import { graphql } from '@/gql';
import type { FetchTaxiVendorsQuery, FetchTaxiVendorsQueryVariables } from '@/gql/graphql';
import { queryExecute } from '@/Utils/graphqlAPI';

export type FetchTaxiVendorsInput = FetchTaxiVendorsQueryVariables;

export type FetchTaxiVendorsOutput = FetchTaxiVendorsQuery['taxiVendors'];
export type FetchTaxiVendorsEmail = FetchTaxiVendorsOutput[number]['emailData'];

export type TaxiVendor = FetchTaxiVendorsOutput[number];

export const fetchTaxiVendors = async ({ partnerCode }: FetchTaxiVendorsInput = {}): Promise<FetchTaxiVendorsOutput> => {
  const response = await queryExecute({
    query: graphql(`
      query FetchTaxiVendors($partnerCode: String) {
        taxiVendors(partnerCode: $partnerCode) {
          id
          codeName
          name
          rideNote
          emailData {
            subject
            main {
              name
              email
            }
            cc {
              name
              email
            }
            partnerNotes
          }
          partners {
            id
            codeName
            name
          }
          partnerTaxiVendors {
            partnerId
            applySubsidyCondition
          }
        }
      }
    `),
    variables: {
      partnerCode,
    },
    fetchPolicy: 'no-cache',
  });

  return response.data.taxiVendors;
};
